module.exports = function getResource(label) {
    const resources = {
        NoResultsTitle: 'Nous n’avons trouvé aucun résultat.',
        NoResultsBody: 'Veuillez répondre de nouveau au questionnaire ci-dessus ou découvrez d’autres questionnaires ci-dessous.'
    };
    return resources[label];
};

